import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ImpersonationGuardService implements CanActivate, CanActivateChild {
    constructor(
        private router: Router
    ) { }

    canActivate(): boolean {
        return this.checkImpersonationFlag();
    }

    canActivateChild(): boolean {
        return this.checkImpersonationFlag();
    }

    private checkImpersonationFlag() {
        const currentUser = localStorage.getItem('currentUser') && JSON.parse(localStorage.getItem('currentUser'));

        if (currentUser && currentUser.hasOwnProperty('IsImpersonated') && String(currentUser.IsImpersonated).toLowerCase() === 'true') {
            this.router.navigate(['/login-impersonificado']);
        }

        return true;
    }
}